module.exports = __webpack_public_path__ + "static/washington-630489e850f0715d869ad2fcf6485d85.png";